import { Howl } from 'howler'
import { getSoundUrl } from '@/utils/assist'

export default {
  data () {
    return {
      bgmSound: new Howl({
        src: [getSoundUrl('FF_BGM_LuckyWheelEvent'), getSoundUrl('FF_BGM_LuckyWheelEvent', 'wav')],
        loop: true
      }),
      toastSound: new Howl({
        src: [getSoundUrl('FF_SFX_WebEvent_UI_Toast'), getSoundUrl('FF_SFX_WebEvent_UI_Toast', 'wav')]
      }),
      clickSound: new Howl({
        src: [getSoundUrl('FF_SFX_WebEvent_UI_Click'), getSoundUrl('FF_SFX_WebEvent_UI_Click', 'wav')]
      }),
      closeDialogSound: new Howl({
        src: [getSoundUrl('FF_SFX_WebEvent_UI_Close'), getSoundUrl('FF_SFX_WebEvent_UI_Close', 'wav')]
      }),
      openDialogSound: new Howl({
        src: [getSoundUrl('FF_SFX_WebEvent_UI_PopUp'), getSoundUrl('FF_SFX_WebEvent_UI_PopUp', 'wav')]
      }),
      discountSound: new Howl({
        src: [getSoundUrl('FF_SFX_LuckyWheelEvent_UI_Discount'), getSoundUrl('FF_SFX_LuckyWheelEvent_UI_Discount', 'wav')]
      }),
      drawSound: new Howl({
        src: [getSoundUrl('FF_SFX_LuckyWheelEvent_UI_Wheel_Loop'), getSoundUrl('FF_SFX_LuckyWheelEvent_UI_Wheel_Loop', 'wav')]
      })
    }
  },
  mounted () {
    document.addEventListener('visibilitychange', () => {
      // 页面处于后台
      if (document.hidden) {
        this.bgmSound.pause()
      } else {
        if (this.$bus.bgmStatus) {
          this.bgmSound.play()
        }
      }
    })
  },
  watch: {
    '$bus.bgmStatus' (current) {
      if (current) {
        this.bgmSound.play()
      } else {
        this.bgmSound.pause()
      }
    },
    '$bus.discountInfo.show': {
      handler (current) {
        if (current && this.$bus.bgmStatus) {
          this.discountSound.play()
        }
      }
    },
    '$bus.drawSound': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.drawSound.play()
          }
        }
      }
    },
    '$bus.clickSound': {
      handler (current) {
        if (current && this.$bus.bgmStatus) {
          this.clickSound.play()
          this.$bus.clickSound = false
        } else {
          this.$bus.clickSound = false
        }
      }
    },
    '$bus.buyDialog.show': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.openDialogSound.play()
          } else {
            this.closeDialogSound.play()
          }
        }
      }
    },
    '$bus.confirmDialog.show': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.openDialogSound.play()
          } else {
            this.closeDialogSound.play()
          }
        }
      }
    },
    '$bus.productsDialog.show': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.openDialogSound.play()
          } else {
            this.closeDialogSound.play()
          }
        }
      }
    },
    '$bus.rule.show': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.openDialogSound.play()
          } else {
            this.closeDialogSound.play()
          }
        }
      }
    },
    '$bus.history.show': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.openDialogSound.play()
          } else {
            this.closeDialogSound.play()
          }
        }
      }
    },
    '$bus.shareInfo.show': {
      handler (current) {
        if (this.$bus.bgmStatus) {
          if (current) {
            this.openDialogSound.play()
          } else {
            this.closeDialogSound.play()
          }
        }
      }
    },
    '$bus.toast.show': {
      handler (current) {
        if (current && this.$bus.bgmStatus) {
          this.toastSound.play()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sound.js